import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(
            _vm.mode == "create"
              ? _vm.$t("data_quality.dataplex.profiling.create_profiling")
              : _vm.mode == "edit"
              ? _vm.$t("data_quality.dataplex.profiling.update_profiling")
              : _vm.$t("data_quality.dataplex.profiling.update_profiling")
          )
        ),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(
                  _vm._s(_vm.$t("data_quality.dataplex.profiling.description"))
                ),
              ]),
            ],
            1
          ),
          _c("template", { slot: "actions" }),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form_profiling", attrs: { id: "form_profiling" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex align-center mb-2" },
                    [
                      _c(
                        VTabs,
                        {
                          ref: "tabs",
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(VTab, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "data_quality.dataplex.profiling.tab_general"
                                )
                              )
                            ),
                          ]),
                          _vm.view
                            ? _c(VTab, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "data_quality.dataplex.profiling.tab_execution"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.show_detail
                            ? _c(VTab, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "data_quality.dataplex.profiling.tab_detail_execution"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.onCancelar },
                            },
                            [_c(VIcon, [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabsItems,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        VTabItem,
                        { staticClass: "mt-3" },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.name"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.display_name,
                                      prefix:
                                        !_vm.view && !_vm.edit
                                          ? _vm.PREFIX
                                          : "",
                                    },
                                    on: { keyup: _vm.onChangeName },
                                    model: {
                                      value: _vm.profiling.display_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "display_name",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.display_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s("ID (Dataplex)"))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_data_scan_id,
                                    attrs: {
                                      filled: "",
                                      readonly: "",
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view || _vm.edit,
                                      rules: _vm.rules.data_scan_id,
                                    },
                                    model: {
                                      value: _vm.profiling.data_scan_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "data_scan_id",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.data_scan_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.description"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(VTextarea, {
                                    attrs: {
                                      filled: _vm.view,
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      rules: _vm.rules.description,
                                      rows: 2,
                                      hint: "(Opcional)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.profiling.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.table"
                                          ) + " (project.dataset.table)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_input_table_input,
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view || _vm.edit,
                                      disabled: _vm.view || _vm.edit,
                                      rules: _vm.rules.table_input,
                                      error: _vm.custom_error.table_input.error,
                                      "error-messages":
                                        _vm.custom_error.table_input.message,
                                    },
                                    on: { blur: _vm.onDetailTable },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append-outer",
                                        fn: function () {
                                          return [
                                            _vm.custom_error.table_input
                                              .error == false
                                              ? _c(
                                                  VIcon,
                                                  {
                                                    attrs: { color: "success" },
                                                  },
                                                  [_vm._v("mdi-check-all")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "progress",
                                        fn: function () {
                                          return [
                                            _vm.custom_error.table_input.loading
                                              ? _c(VProgressLinear, {
                                                  attrs: {
                                                    color: "primary",
                                                    value: "0",
                                                    indeterminate:
                                                      _vm.custom_error
                                                        .table_input.loading,
                                                    height: _vm.custom_error
                                                      .table_input.loading
                                                      ? 1
                                                      : 0,
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.profiling.table_input,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "table_input",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.table_input",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.table_last_modification"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_input_table_input_last,
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: "",
                                      disabled: "",
                                      value: _vm.last_modification_table,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.sample_size"
                                          ) + "(%)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      min: "1",
                                      max: "100",
                                      type: "number",
                                      rules: [
                                        function (v) {
                                          return !!v || "Campo requerido."
                                        },
                                      ],
                                      filled: _vm.view,
                                    },
                                    model: {
                                      value: _vm.profiling.sampling_percent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "sampling_percent",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.sampling_percent",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.row_filter"
                                          ) + " (discount_pct > 50)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      filled: _vm.view,
                                      hint: "(Opcional)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.profiling.row_filter,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "row_filter",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.row_filter",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.columns_included"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VAutocomplete, {
                                    attrs: {
                                      items:
                                        _vm.table_input &&
                                        _vm.table_input.schema
                                          ? _vm.table_input.schema.fields
                                          : [],
                                      multiple: "",
                                      outlined: "",
                                      dense: "",
                                      filled: _vm.view,
                                      readonly: _vm.view,
                                      "item-text": "name",
                                      "item-value": "name",
                                      "hide-details": "auto",
                                      chips: "",
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("common.field_required")
                                          )
                                        },
                                      ],
                                      "search-input": _vm.searchInclude,
                                    },
                                    on: {
                                      "update:searchInput": function ($event) {
                                        _vm.searchInclude = $event
                                      },
                                      "update:search-input": function ($event) {
                                        _vm.searchInclude = $event
                                      },
                                      change: function ($event) {
                                        _vm.searchInclude = ""
                                      },
                                      blur: function ($event) {
                                        _vm.searchInclude = ""
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        _vm.searchInclude = ""
                                      },
                                    },
                                    model: {
                                      value: _vm.profiling.include_fields,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "include_fields",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.include_fields",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.columns_excluded"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VAutocomplete, {
                                    attrs: {
                                      items:
                                        _vm.table_input &&
                                        _vm.table_input.schema
                                          ? _vm.table_input.schema.fields
                                          : [],
                                      multiple: "",
                                      outlined: "",
                                      dense: "",
                                      filled: _vm.view,
                                      readonly: _vm.view,
                                      "item-text": "name",
                                      "item-value": "name",
                                      "hide-details": "auto",
                                      chips: "",
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("common.field_required")
                                          )
                                        },
                                      ],
                                      "search-input": _vm.searchExclude,
                                    },
                                    on: {
                                      "update:searchInput": function ($event) {
                                        _vm.searchExclude = $event
                                      },
                                      "update:search-input": function ($event) {
                                        _vm.searchExclude = $event
                                      },
                                      change: function ($event) {
                                        _vm.searchExclude = ""
                                      },
                                      blur: function ($event) {
                                        _vm.searchExclude = ""
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        _vm.searchExclude = ""
                                      },
                                    },
                                    model: {
                                      value: _vm.profiling.exclude_fields,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "exclude_fields",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.exclude_fields",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.scope"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    VRadioGroup,
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        row: "",
                                        disabled: _vm.view,
                                        small: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.profiling.scope,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.profiling, "scope", $$v)
                                        },
                                        expression: "profiling.scope",
                                      },
                                    },
                                    [
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.profiling.fields.scope_incremental"
                                          ),
                                          value: "INCREMENTAL",
                                        },
                                      }),
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.profiling.fields.scope_complete"
                                          ),
                                          value: "FULL",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "2" } }),
                              _c(VCol, { attrs: { cols: "10" } }, [
                                _vm.profiling.scope == "INCREMENTAL"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.profiling.fields.scope_period"
                                                    ),
                                                    items: _vm.scope_periods,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "common.field_required"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.profiling
                                                        .scope_period,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.profiling,
                                                        "scope_period",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profiling.scope_period",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.profiling.scope == "INCREMENTAL"
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VAutocomplete, {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.profiling.fields.scope_column"
                                                        ),
                                                        items: _vm.time_columns,
                                                        outlined: "",
                                                        dense: "",
                                                        filled: _vm.view,
                                                        disabled: _vm.view,
                                                        "item-text": "name",
                                                        "item-value": "name",
                                                        "hide-details": "auto",
                                                        rules: [
                                                          function (v) {
                                                            return (
                                                              !!v ||
                                                              _vm.$t(
                                                                "common.field_required"
                                                              )
                                                            )
                                                          },
                                                        ],
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.profiling
                                                            .scope_column,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.profiling,
                                                            "scope_column",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "profiling.scope_column",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.profiling.scope == "INCREMENTAL"
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VCheckbox, {
                                                      staticClass: "mt-0",
                                                      attrs: {
                                                        outlined: "",
                                                        dense: "",
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.scope_closed_label"
                                                        ),
                                                        "persistent-hint": "",
                                                        hint: _vm.$t(
                                                          "data_quality.dataplex.scope_closed_hint"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.profiling
                                                            .scope_closed,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.profiling,
                                                            "scope_closed",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "profiling.scope_closed",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.schedule_execution"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    VRadioGroup,
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        row: "",
                                        disabled: _vm.view,
                                        small: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.profiling.cron_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.profiling,
                                            "cron_type",
                                            $$v
                                          )
                                        },
                                        expression: "profiling.cron_type",
                                      },
                                    },
                                    [
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.profiling.fields.schedule_unique"
                                          ),
                                          value: "UNIQUE",
                                        },
                                      }),
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.profiling.fields.schedule_cron"
                                          ),
                                          value: "CRON",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "2" } }),
                              _c(VCol, { attrs: { cols: "10" } }, [
                                _vm.profiling.cron_type == "CRON"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.profiling.fields.schedule_period"
                                                    ),
                                                    items: _vm.cron_periods,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "common.field_required"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.profiling.cron_period,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.profiling,
                                                        "cron_period",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profiling.cron_period",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.profiling.cron_period ==
                                              _vm.PERIODS.ONE_MONTH ||
                                            _vm.profiling.cron_period ==
                                              _vm.PERIODS.ONE_WEEK
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VSelect, {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.profiling.fields.schedule_day"
                                                        ),
                                                        items:
                                                          _vm.profiling
                                                            .cron_period ==
                                                          _vm.PERIODS.ONE_MONTH
                                                            ? _vm.cron_days
                                                            : _vm.cron_days_week,
                                                        dense: "",
                                                        outlined: "",
                                                        disabled: _vm.view,
                                                        filled: _vm.view,
                                                        "hide-details": "auto",
                                                        rules: [
                                                          function (v) {
                                                            return (
                                                              !!v ||
                                                              "Campo requerido."
                                                            )
                                                          },
                                                        ],
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.profiling
                                                            .cron_day,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.profiling,
                                                            "cron_day",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "profiling.cron_day",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.profiling.fields.schedule_hour"
                                                    ),
                                                    items: _vm.cron_hours,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          "Campo requerido."
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.profiling.cron_hour,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.profiling,
                                                        "cron_hour",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profiling.cron_hour",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profiling.cron_type == "UNIQUE"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VSubheader,
                                          {
                                            staticClass:
                                              "font-weight-bold mb-1",
                                          },
                                          [_vm._v("Rango de datos a procesar")]
                                        ),
                                        _vm.profiling.column_time &&
                                        _vm.numRowsTable > _vm.numRowsAllowed
                                          ? _c(
                                              VAlert,
                                              {
                                                staticClass: "py-1 mb-2",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  text: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.rowsLimitText)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              VAlert,
                                              {
                                                staticClass: "py-1 mb-2",
                                                attrs: {
                                                  type: "info",
                                                  dense: "",
                                                  text: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Opcional. Permite limitar la ejecución a un rango de fechas respecto a la columna de tiempo seleccionada."
                                                ),
                                              ]
                                            ),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VAutocomplete, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.profiling.fields.schedule_column"
                                                    ),
                                                    items: _vm.time_columns,
                                                    outlined: "",
                                                    dense: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "item-text": "name",
                                                    "item-value": "name",
                                                    "hide-details": "auto",
                                                    id: "column_time",
                                                    name: "column_time",
                                                    rules:
                                                      _vm.profiling
                                                        .column_time &&
                                                      _vm.numRowsTable >
                                                        _vm.numRowsAllowed
                                                        ? [_vm.rules.required]
                                                        : [],
                                                    hint:
                                                      _vm.profiling
                                                        .column_time &&
                                                      _vm.numRowsTable >
                                                        _vm.numRowsAllowed
                                                        ? "Requerido para tablas grandes"
                                                        : "Opcional",
                                                    "persistent-hint": "",
                                                    bottom: "",
                                                    right: "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.profiling.column_time,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.profiling,
                                                        "column_time",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "profiling.column_time",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "TextFieldCalendarComponent",
                                                  {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "data_quality.dataplex.profiling.fields.date_from"
                                                      ),
                                                      disabled: _vm.view,
                                                      filled: _vm.view,
                                                      rules: _vm.profiling
                                                        .column_time
                                                        ? [
                                                            function (v) {
                                                              return (
                                                                !!v ||
                                                                "Campo requerido."
                                                              )
                                                            },
                                                          ]
                                                        : [],
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.profiling
                                                          .column_time_from,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.profiling,
                                                          "column_time_from",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profiling.column_time_from",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "TextFieldCalendarComponent",
                                                  {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "data_quality.dataplex.profiling.fields.date_till"
                                                      ),
                                                      disabled: _vm.view,
                                                      filled: _vm.view,
                                                      rules: _vm.profiling
                                                        .column_time
                                                        ? [
                                                            function (v) {
                                                              return (
                                                                !!v ||
                                                                "Campo requerido."
                                                              )
                                                            },
                                                          ]
                                                        : [],
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.profiling
                                                          .column_time_until,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.profiling,
                                                          "column_time_until",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profiling.column_time_until",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.notification"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c("TextFieldRecipientsComponent", {
                                    attrs: {
                                      disabled: _vm.view,
                                      filled: _vm.view,
                                    },
                                    model: {
                                      value: _vm.profiling.recipients,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.profiling,
                                          "recipients",
                                          $$v
                                        )
                                      },
                                      expression: "profiling.recipients",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                [
                                  _c(VDataTable, {
                                    key: _vm.key_table_executions,
                                    staticClass: "table-inca",
                                    attrs: {
                                      headers: _vm.headers_executions,
                                      items: _vm.executions,
                                      "sort-by":
                                        _vm.pagination_executions.sort_by,
                                      "sort-desc":
                                        _vm.pagination_executions.sort_desc,
                                      "hide-default-footer": true,
                                      page: _vm.pagination_executions.current,
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.pagination_executions,
                                          "current",
                                          $event
                                        )
                                      },
                                      pagination: function ($event) {
                                        _vm.pagination_executions.total =
                                          $event.itemsLength
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.state",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.DATAPLEX_STATES[
                                                    item.state
                                                  ]
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.startTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.startTime
                                                    ? _vm.formatDate(
                                                        item.startTime
                                                      )
                                                    : _vm.formatDate(
                                                        item.created_date
                                                      )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.endTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(item.endTime)
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.actions",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { text: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onPingExecution(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  [
                                                    _vm._v("mdi-broadcast"),
                                                    _c("PING"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { text: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onViewDetailExecution(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  [
                                                    _vm._v("icon-view"),
                                                    _c("DETALLE"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.show_detail
                        ? _c(VTabItem, [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("b", [
                                  _vm._v(
                                    "JOB: " +
                                      _vm._s(_vm.execution_selected.name)
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("ProfilingExecutionDetailComponent", {
                                    attrs: {
                                      items:
                                        _vm.execution_selected &&
                                        _vm.execution_selected
                                          .dataProfileResult &&
                                        _vm.execution_selected.dataProfileResult
                                          .profile &&
                                        _vm.execution_selected.dataProfileResult
                                          .profile.fields
                                          ? _vm.execution_selected
                                              .dataProfileResult.profile.fields
                                          : [],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(VRow, { attrs: { justify: "center" } }, [
            _c(
              "div",
              { staticClass: "mb-2" },
              [
                _vm.view == false && _vm.tab != 2
                  ? _c(
                      VBtn,
                      {
                        staticClass: "primary mr-1",
                        attrs: {
                          id: "btn_save_profiling",
                          name: "btn_save_profiling",
                        },
                        on: {
                          click: function ($event) {
                            _vm.edit
                              ? _vm.onUpdateProfiling()
                              : _vm.onSaveProfiling()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("btns.save")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }